import IBaseRespone from '../../model/respone/IBaseRespone';
import httpClient from '../httpService';
import { BSKT_DotHoc } from './DotHocModels';

const DotHocApiUrl = '/api/dothoc/';

function normalizeResponsePayload(payload: any): any {
    if (typeof payload !== 'string') return payload;

    try {
        return JSON.parse(payload);
    } catch {
        return payload;
    }
}

function unwrapDotHocArrayResponse(res: any): BSKT_DotHoc[] {
    const payload = normalizeResponsePayload(res);
    if (Array.isArray(payload)) return payload;
    if (Array.isArray(payload?.data)) return payload.data;
    if (Array.isArray(payload?.data?.data)) return payload.data.data;
    if (Array.isArray(payload?.data?.items)) return payload.data.items;
    if (Array.isArray(payload?.items)) return payload.items;
    return [];
}

function unwrapDotHocItemResponse(res: any): BSKT_DotHoc | null {
    const payload = normalizeResponsePayload(res);
    if (payload && typeof payload === 'object' && 'ID_dot_hoc' in payload) return payload as BSKT_DotHoc;
    if (payload?.data && typeof payload.data === 'object' && 'ID_dot_hoc' in payload.data) return payload.data as BSKT_DotHoc;
    if (payload?.data?.data && typeof payload.data.data === 'object' && 'ID_dot_hoc' in payload.data.data) {
        return payload.data.data as BSKT_DotHoc;
    }
    return null;
}

function unwrapDotHocResponse(res: any): IBaseRespone<BSKT_DotHoc> {
    const payload = normalizeResponsePayload(res);
    const data = unwrapDotHocItemResponse(payload) ?? unwrapDotHocItemResponse(payload?.data) ?? payload?.data ?? undefined;
    const isSuccess =
        typeof payload?.is_success === 'boolean'
            ? payload.is_success
            : Number(payload?.status_code ?? 0) === 200 || !!data;

    return {
        is_success: isSuccess,
        message: payload?.message,
        status_code: payload?.status_code ?? (isSuccess ? 200 : 400),
        data
    };
}

export const dotHocService = {
    getHeDaoTao: async (): Promise<{ID_he:number;Ten_he:string;NghienCuuSinh:boolean}[]> => {
        const res=await httpClient.get(DotHocApiUrl+'HeDaoTao');
        if((res as any)?.is_success===false||res?.data?.is_success===false||!Array.isArray(res?.data?.data))throw Error('Không tải được danh mục hệ đào tạo.');
        return res.data.data;
    },
    getAll: async (strict = false): Promise<BSKT_DotHoc[]> => {
        const res = await httpClient.get(DotHocApiUrl + 'selectAll');
        if (strict && ((res as any)?.is_success === false || res?.data?.is_success === false)) throw Error('Period request failed');
        return unwrapDotHocArrayResponse(res);
    },
    getById: async (id: number): Promise<BSKT_DotHoc> => {
        const res = await httpClient.get(DotHocApiUrl + 'selectById', {
            params: { ID_dot_hoc: id }
        });
        return (
            unwrapDotHocItemResponse(res) ?? {
                ID_dot_hoc: 0,
                ID_he: 0,
                Dot: 0,
                Nam_tuyen_sinh: 0,
                Ten_dot: '',
                Tu_ngay: '',
                Den_ngay: '',
                Ghi_chu: ''
            }
        );
    },
    create: async (dotHoc: BSKT_DotHoc): Promise<IBaseRespone<BSKT_DotHoc>> => {
        const res = await httpClient.post(DotHocApiUrl + 'insert', dotHoc);
        return unwrapDotHocResponse(res.data ?? res);
    },
    update: async (dotHoc: BSKT_DotHoc): Promise<IBaseRespone<BSKT_DotHoc>> => {
        const res = await httpClient.post(DotHocApiUrl + 'update', dotHoc);
        return unwrapDotHocResponse(res.data ?? res);
    },
    delete: async (id: number): Promise<IBaseRespone<BSKT_DotHoc>> => {
        const res = await httpClient.post(DotHocApiUrl + 'delete', null, {
            params: { ID_dot_hoc: id }
        });
        return unwrapDotHocResponse(res.data ?? res);
    }
};
